/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IInstitution } from 'app/shared/model/institution.model';
import { IAccountingCurrency } from 'app/shared/model/accounting-currency.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { IAccountingTax } from 'app/shared/model/accounting-tax.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';

export interface IAccountingBankAccount {
  id?: string;
  accountHolderName?: string | null;
  accountNo?: string | null;
  ifscCode?: string | null;
  allowedCredit?: number | null;
  maxCreditLimit?: number | null;
  standardCreditLimit?: number | null;
  inactive?: boolean | null;
  active?: boolean | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  lastUpdated?: number | null;
  cursor?: number | null;
  entityId?: string | null;
  openingBalance?: number | null;
  overDraft?: boolean | null;
  closingBalance?: number | null;
  createdById?: string | null;
  createdByType?: keyof typeof AddedByType | null;
  institution?: IInstitution | null;
  baseCurrency?: IAccountingCurrency | null;
  accountType?: IClinicalDictionary | null;
  entityType?: IClinicalDictionary | null;
  taxes?: IAccountingTax[] | null;
  otherCurrencies?: IAccountingCurrency[] | null;
}

export const defaultValue: Readonly<IAccountingBankAccount> = {
  inactive: false,
  active: false,
  overDraft: false,
};
